var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventShareButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 31,
    viewBox: "0 0 22 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.0625 30.25C1.5125 30.25 1.03125 30.0437 0.61875 29.6312C0.20625 29.2187 0 28.7375 0 28.1875V10.6906C0 10.1406 0.20625 9.65938 0.61875 9.24687C1.03125 8.83437 1.5125 8.62813 2.0625 8.62813H7.87188V10.6906H2.0625V28.1875H19.9375V10.6906H14.0594V8.62813H19.9375C20.4875 8.62813 20.9687 8.83437 21.3812 9.24687C21.7937 9.65938 22 10.1406 22 10.6906V28.1875C22 28.7375 21.7937 29.2187 21.3812 29.6312C20.9687 30.0437 20.4875 30.25 19.9375 30.25H2.0625ZM9.93438 19.6969V3.9875L6.90937 7.0125L5.43125 5.53438L10.9656 0L16.5 5.53438L15.0219 7.0125L11.9969 3.9875V19.6969H9.93438Z",
    fill: "#C2B58C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventShareButton);
export default __webpack_public_path__ + "static/media/event-share-button.908344eb231835fd17afdbb03610a251.svg";
export { ForwardRef as ReactComponent };